export * from './colorMaps'
export * from './fontFormats'
export * from './templates'
export const BASE_URL = `${window.location.protocol}//${window.location.host}`
